import { v4 as uuidv4 } from 'uuid';

export const generateSessionId = () => {
  return uuidv4();
};

export const initSession = () => {
  // Generate new session ID
  const sessionId = generateSessionId();
  
  // Store in window.eventData
  if (!window.eventData) {
    window.eventData = {};
  }
  window.eventData.sessionId = sessionId;
  
  return sessionId;
};

export const getCurrentSessionId = () => {
  return window.eventData?.sessionId;
};

// Handle page refresh
window.addEventListener('beforeunload', () => {
  // Generate new session ID for next page load
  const newSessionId = generateSessionId();
  if (window.eventData) {
    window.eventData.nextSessionId = newSessionId;
  }
});

// Initialize new session on page load
window.addEventListener('load', () => {
  if (window.eventData?.nextSessionId) {
    window.eventData.sessionId = window.eventData.nextSessionId;
    delete window.eventData.nextSessionId;
  } else {
    initSession();
  }
}); 